import { useRef, useState } from 'react';
import Card from "../Card/Card";
import { motion } from "framer-motion";
import { Copy } from "lucide-react"; // icons
import './Display.css'; // Import the CSS file for styling


const displayProperties = [
  { name: "Block", value: `<div class="carve-block">Block</div>`, description: "Takes up full width, stacks vertically", cssCode: "display: block;", color: "carve-bg-blue-500" },
  { name: "Inline", value: `<div class="carve-inline">Inline</div>`, description: "Flows with text, ignores width/height", cssCode: "display: inline;", color: "carve-bg-purple-500" },
  { name: "Inline-Block", value: `<div class="carve-inline-block">Inline-block</div>`, description: "Flows inline but respects width/height", cssCode: "display: inline-block;", color: "carve-bg-green-500" },
  { name: "Flex", value: `<div class="carve-flex">flex</div>`, description: "Flexible box layout container", cssCode: "display: flex;", color: "carve-bg-red-500" },
  { name: "Grid", value: `<div class="carve-grid">Grid</div>`, description: "Two-dimensional grid layout", cssCode: "display: grid;\ngrid-template-columns: repeat(3, 1fr);", color: "carve-bg-yellow-500" },
  { name: "None", value: `<div class="carve-none">None</div>`, description: "Element is completely hidden", cssCode: "display: none;", color: "carve-bg-gray-500" },
  { name: "Table", value: `<div class="carve-table">Table</div>`, description: "Behaves like a table element", cssCode: "display: table;", color: "carve-bg-indigo-500" },
  { name: "Inline-Flex", value: `<div class="carve-inline-flex">Inline-flex</div>`, description: "Inline-level flex container", cssCode: "display: inline-flex;", color: "carve-bg-pink-500" }
];


const Display = () => {
  const [selectedDisplay, setSelectedDisplay] = useState("block");
  const snippetContainerRef = useRef(null);
  const [showScanning, setShowScanning] = useState(false);

  const selectedProperty = displayProperties.find((prop) => prop.value === selectedDisplay);


  const copySnippet = () => {
    if (snippetContainerRef.current) {
      const range = document.createRange();
      range.selectNode(snippetContainerRef.current);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();

      setShowScanning(true);
      setTimeout(() => setShowScanning(false), 1000);
    }
  };

  return (
    <motion.div initial={{ y: 10, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ duration: 0.2 }}>
      <div className="carve-min-h-screen carve-bg-gradient-to-br carve-from-slate-50 carve-to-blue-50 carve-p-8">

        {/* Buttons */}
        <div className="carve-button-group flex-wrap-wrap">
          {displayProperties.map((p) => (
            <button
              key={p.value}
              onClick={() => setSelectedDisplay(p.value)}
              className={` ${selectedDisplay === p.value ? "carve-button-main" : "carve-button-vice"
                }`}>
              <div className={`carve-w-8 carve-h-8 ${p.color} carve-rounded-md carve-mb-2 carve-mx-auto`}></div>
              <div className="">{p.name}</div>
            </button>
          ))}
        </div>


        {/* Info + Copy */}
        {selectedProperty && (
          <div className="carve-bg-white carve-p-6 carve-rounded-lg carve-shadow carve-mb-8">
            <div className="carve-flex carve-justify-between carve-items-start carve-mb-4">

              <div className={`center-container ${showScanning ? 'scanning' : ''}`}>

                <div className='snippet' ref={snippetContainerRef}>
                  <pre>
                    <code className="carve-text-xl carve-font-semibold">{selectedProperty.value}</code>
                  </pre>
                </div>
                <button aria-label="Copy Button" onClick={copySnippet}>
                  <Copy />
                </button>

              </div>
            </div>
            <p className="carve-space-top-hefty carve-space-bottom-hefty">{selectedProperty.description}</p>
          </div>
        )}
      </div>
    </motion.div>
  );
};



const displayCard = () => {
  return (
    <Card CardTitle="Display" CardBody={<Display />} />
  );
};


export default displayCard;
